import { loginRes } from '../../Login.res';

// https://jira.lais.net/browse/WEB-39857
export const res = {
  title: {
    is: 'Innskráning með rafrænum skilríkjum',
    en: 'Login with electronic ID',
    pl: 'Logowanie identyfikacją elektroniczną',
  } as const,
  login: {
    ...loginRes.loginButtonText,
  } as const,
  authenticate: {
    ...loginRes.authenticateButtonText,
  } as const,
  phonenumber: {
    is: 'Símanúmer',
    en: 'Phone number',
    pl: 'Numer telefonu',
  } as const,
  validationPhonenumberRequired: {
    is: 'Símanúmer verður að vera útfyllt',
    en: 'Phone number is a required field',
    pl: 'Należy wypełnić pole z numerem telefonu',
  } as const,
  validationPhonenumberInvalid: {
    is: 'Símanúmer er ekki rétt skráð',
    en: 'Phone number is incorrect',
    pl: 'Numer telefonu jest niepoprawny',
  } as const,
  linkTitle: {
    is: 'Nánar um rafræn skilríki á SIM korti',
    // TODO: Translate
  } as const,
};
